// creates a function which insert or updates item with specified id
export function createUpserter<TDefault extends { id: string }, T extends { id: string } = TDefault>(createDefault: (id: string) => TDefault) {

  return createGenericUpserter<'id', TDefault, T>('id', createDefault)

  // return (state: T[], id: string, updater: (data: TDefault | T) => T | false) => {

  //   const index = state.findIndex((x) => x.id === id);
  //   let item = index === -1 ? createDefault(id) : state[index];
  //   const updated = updater(item);
  //   if (updated !== false) {
  //     item = { ...updated };
  //   }

  //   if (index === -1) {
  //     // always insert new item
  //     return [ item, ...state ];
  //   }

  //   if (updated === false) {
  //     // do not update if updater returns false
  //     return state;
  //   }

  //   return [ ...state.slice(0, index), item, ...state.slice(index + 1) ];
  // };
}

export function createGenericUpserter<TKey extends keyof T, TDefault, T = TDefault>(key: TKey,
                                                        createDefault: (key: T[TKey]) => TDefault) {

  return (state: T[], keyValue: T[TKey], updater: (data: TDefault | T) => T | false) => {

    const index = state.findIndex((x) => x[key] === keyValue);
    let item = index === -1 ? createDefault(keyValue) : state[index];
    const updated = updater(item);
    if (updated !== false) {
      item = { ...updated };
    }

    if (index === -1) {
      // always insert new item
      return [ item, ...state ];
    }

    if (updated === false) {
      // do not update if updater returns false
      return state;
    }

    return [ ...state.slice(0, index), item, ...state.slice(index + 1) ];
  };
}
